import { isEmpty } from 'lodash';

import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function setQuizResults({ commit }, { quizResults, cardId }) {
  commit(types.SET_QUIZ_RESULTS, { quizResults, cardId });

  return Promise.resolve(quizResults);
}

export function fetchQuizResults({ dispatch }, { params, cardId }) {
  return http.get(`${MINERVA_API_URL}/quiz_results`, { params })
    .then(resp => dispatch('setQuizResults', { quizResults: resp.data, cardId }));
}

export function setQuizResult({ commit }, { quizResult, cardId }) {
  commit(types.SET_QUIZ_RESULT, { quizResult, cardId });

  return Promise.resolve(quizResult);
}

/* eslint-disable max-len */
export function createQuizResult({ dispatch }, { quiz, option, cardId, duration, answerValue }) {
  return http.patch(`${MINERVA_API_URL}/assignments/${cardId}/quiz_results`, {
    page_id: quiz.id,
    answer_id: option ? option.id : undefined,
    value: answerValue,
    duration,
  })
    .then(resp => dispatch('setQuizResult', { quizResult: resp.data, cardId }))
    .catch(err => Promise.reject(err));
}

export function updateQuizResult({ dispatch, state }, { quiz, option, cardId, duration, answerValue }) {
  const quizResult = state.quizResults[quiz.id];

  return http.patch(`${MINERVA_API_URL}/assignments/${cardId}/quiz_results/${quizResult.id}`, {
    page_id: quiz.id,
    answer_id: option ? option.id : undefined,
    value: answerValue,
    duration,
  })
    .then(resp => dispatch('setQuizResult', { quizResult: resp.data, cardId }))
    .catch(err => Promise.reject(err));
}

export function saveQuizResult({ dispatch, state }, { quiz, option, cardId, duration, answerValue }) {
  const quizResult = state.quizResults[cardId] ? state.quizResults[cardId][quiz.id] : {};

  if (isEmpty(quizResult)) {
    return dispatch('createQuizResult', { quiz, option, cardId, duration, answerValue });
  }

  return dispatch('updateQuizResult', { quiz, option, cardId, duration, answerValue });
}
